import { CarveOutCombo } from "../../../../services/verifyService/model/verification/CarveoutCombo";
import { EstimatedProcedure } from "../../../../services/verifyService/model/verification/EstimatedProcedure";

/**
 * Applies carve-out rules to determine which additional procedures need to be added.
 * Uses data-driven approach: the CarveOutCombo contains all necessary info (Code, Description, TotalCodeCount).
 */
export class CarveOutRules {
  /**
   * Calculates and returns additional procedures needed based on the carve-out rule.
   * 
   * @param carveOutCode - The matched carve-out combo containing code, description, and required count
   * @param procs - Existing procedures already in the estimate
   * @returns Array of new EstimatedProcedure objects to add (distinct instances, not shared references)
   */
  static Apply(carveOutCode: CarveOutCombo, procs: EstimatedProcedure[]): EstimatedProcedure[] {
    // Count how many of this code already exist
    const existingCount = procs.filter(proc => proc.code === carveOutCode.Code).length;
    
    // Calculate how many more are needed to meet the required count
    const needed = Math.max(0, carveOutCode.TotalCodeCount - existingCount);
    
    // Create distinct instances using Array.from (avoids .fill() shared reference bug)
    return Array.from({ length: needed }, () => 
      new EstimatedProcedure(
        carveOutCode.Code, 
        carveOutCode.Description || `Procedure ${carveOutCode.Code}`
      )
    );
  }
}